<template lang="pug">
#BoundarySelector
    label#stage-label.title Select enrolment year:
    .guidance(v-show="!stage")
        | School zones can change between enrolment years. Select the year you are seeking enrolment.
    #stages.school-types
        .top-group(v-for="stageOption in stages")
            input(type="radio" :id="`stage-${stageOption}`" v-model="stage" :value="stageOption")
            label.btn.stage.round-left(:for="`stage-${stageOption}`") {{ stageOption }}

    div(v-show="stage")
        label#school-type-label.title(aria-label="Use arrows to choose a school type") Select school type:
        .guidance(v-show="false && !selectedYearGroup")
            | There are three types of government schools:
            br
            b Primary
            | schools;
            br
            b Secondary
            | schools; and
            br
            b Specialist schools
            | , which specialise in teaching children with a disability or additional needs.
        .school-types
            #primary.top-group
                input#yeargroup-primary(type="radio" v-model="selectedYearGroup" value="primary" aria-describedby="school-type-label" aria-label="Primary schools" @change="change")
                label.btn.yeargroup.round-left(for="yeargroup-primary") Primary
            #secondary.top-group
                input#yeargroup-secondary(type="radio" v-model="selectedYearGroup" value="secondary" aria-describedby="school-type-label" aria-label="Secondary schools. More options available for this school type by using the down arrow." @change="change")
                label.btn.yeargroup(for="yeargroup-secondary") Secondary
            #specialist.top-group
                input#yeargroup-specialist(type="radio" v-model="selectedYearGroup" value="specialist" aria-describedby="school-type-label" aria-label="Specialist schools." @change="change")
                label.btn.yeargroup.round-right(for="yeargroup-specialist") Specialist
            .secondary-options(v-if="selectedYearGroup === 'secondary'")
                .multiple-year-group
                    span(v-for="year in this.secondaryYears.slice(0,6)")
                        input(:id="'year-' + year" type="radio" name="years" v-model="selectedSecondaryYear" :value="year" aria-describedby="school-type-label" :aria-label="`Secondary school ${year}`" @change="change")
                        label.btn(:for="'year-' + year") {{ year.replace('year','') }}
                .multiple-year-group.multiple-year-group-categories
                    input#year-juniorsec(type="radio" name="categories" v-model="selectedSecondaryYear" value="juniorsec" aria-describedby="school-type-label" aria-label="Junior Secondary Schools" @change="change")
                    label.btn(for="year-juniorsec") Junior Secondary only

                    input#year-seniorsec(type="radio" name="categories"  v-model="selectedSecondaryYear" value="seniorsec" aria-describedby="school-type-label" aria-label="Senior Secondary Schools" @change="change")
                    label.btn(for="year-seniorsec") Senior Secondary only

                    input#year-singlesex(type="radio" name="categories"  v-model="selectedSecondaryYear" value="singlesex" aria-describedby="school-type-label" aria-label="Single Sex Schools" @change="change")
                    label.btn(for="year-singlesex") Single Sex
            .specialisation-options(v-if="0 && selectedYearGroup === 'specialist'")
                .multiple-year-group.multiple-year-group-categories
                    input#specialisation-all(type="radio" name="categories" v-model="selectedSpecialisation" value="all")
                    label.btn.bold(for="specialisation-all") Show all

                    input#specialisation-asd(type="radio" name="categories" v-model="selectedSpecialisation" value="asd")
                    label.btn(for="specialisation-asd") Autism
                        .description Specialist school providing education and support for students with autism.

                    input#specialisation-deaf(type="radio" name="categories" v-model="selectedSpecialisation" value="deaf")
                    label.btn(for="specialisation-deaf") Deaf Education
                        .description Auslan language school providing education and support for students who are deaf or hard of hearing.

                    input#specialisation-id-mild(type="radio" name="categories" v-model="selectedSpecialisation" value="id-mild")
                    label.btn(for="specialisation-id-mild") Intellectual Disability - mild
                        .description Schools providing education and support for students with an intellectual disability.

                    input#specialisation-id-moderate(type="radio" name="categories" v-model="selectedSpecialisation" value="id-moderate")
                    label.btn(for="specialisation-id-moderate") Intellectual Disability - moderate
                        .description Schools providing education and support for students with an intellectual disability.

                    input#specialisation-id-profound(type="radio" name="categories" v-model="selectedSpecialisation" value="id-profound")
                    label.btn(for="specialisation-id-profound") Intellectual Disability - profound
                        .description Schools providing education and support for students with an intellectual disability.

                    input#specialisation-physical(type="radio" name="categories" v-model="selectedSpecialisation" value="physical")
                    label.btn(for="specialisation-physical") Physical Disability
                        .description Schools providing education and support for students with a physical disability.

                    input#specialisation-hub(type="radio" name="categories" v-model="selectedSpecialisation" value="hub")
                    label.btn(for="specialisation-hub") Specialist Inclusion Hub
                        .description Neighborhood school with professional capacity and physical design to provide specialist education and support for students with
                            | disability in mainstream classroom settings.
        //- .specialisation-prompt(v-if="selectedYearGroup === 'specialist' && showPrompt" @click="showPrompt=false")
        //-     p Every child is entitled to enrol at their local neighborhood school. Don't forget to check the Primary or Secondary tab first.
        //-     label.btn.w100 I understand.
</template>

<script>
import { EventBus } from './EventBus';

export default {
    name: 'BoundarySelector',
    data: () => ({
        stage: getCookie('stage', undefined /*'2020'*/),
        selectedSecondaryYear: getCookie('selectedSecondaryYear', 'year7'),
        selectedYearGroup: getCookie('selectedYearGroup', '' /*'primary'*/),
        selectedSpecialisation: 'all',
        selectedSpecialisationCategories: undefined,
        // showPrompt: true//window.localStorage.getItem('showPrompt') || true
    }),
    computed: {
        boundarySet() {
            return this.year === 'other' ? null : this.schoolSet;
        },
        boundarySetTitle() {
            return this.getBoundarySetTitle(this.year);
        },
        boundarySetStageTitle() {
            return this.getBoundarySetTitle(this.year, true);
        },
        schoolSet() {
            return this.year && this.stage
                ? `${this.year}-${this.stage}`
                : undefined;
        },
        year() {
            if (this.selectedYearGroup.match('primary|specialist|other')) {
                return this.selectedYearGroup;
            } else if (this.selectedYearGroup === 'secondary') {
                return this.selectedSecondaryYear;
            }
            return null;
        },
        year_stage() {
            return `${this.year}_${this.stage}`;
        },
        secondaryYears() {
            return ['year7', 'year8', 'year9', 'year10', 'year11', 'year12'];
        },
        limitedYears() {
            return ['juniorsec', 'seniorsec', 'singlesex'];
        },
        stages() {
            return window.app.stages;
        },
    },
    watch: {
        boundarySet: {
            handler() {
                window.app.App.hasBoundarySet = true;
                window.localStorage.setItem(
                    'selectedSecondaryYear',
                    this.selectedSecondaryYear
                );
                window.localStorage.setItem(
                    'selectedYearGroup',
                    this.selectedYearGroup
                );
                window.localStorage.setItem('stage', this.stage);
                window.track(
                    'BoundarySelector',
                    'boundaryset',
                    this.boundarySet
                );
                // console.log(this.boundarySet);
                // this.$emit('boundarySetChanged', this.boundarySet, this);
                EventBus.$emit(
                    'boundarySetChanged',
                    this.boundarySet,
                    this,
                    this._nextSource
                );
                /*
                The use case that we're trying to support:
                - changing boundary set while an address is entered looks up the school for that address in the new combo
                - clicking on a school always ends up showing the school (with boundary set)
                - searching for a school always ends up showing the school (with boundary set)

                The two use cases that nextSource is trying to solve:
                - clicking a school triggers a boundary set change which then triggers a school search which sometimes comes up with nothing
                - clicking a boundary set
                */
                this._nextSource = null;
            },
            immediate: true,
        },
        schoolSet() {
            this.$emit('schoolSetChanged', this.schoolSet, this);
            EventBus.$emit('schoolSetChanged', this.schoolSet, this);
        },
        /*selectedSpecialisation() {
            this.selectedSpecialisationCategories = {
                asd: ['Autism Spectrum Disorder'],
                deaf: ['Deaf education'],
                'id-mild':  ['Intellectual Disability (mild)', 'Intellectual Disability (mild to profound)'],
                'id-moderate': ['Intellectual Disability (moderate to profound)', 'Intellectual Disability (mild to profound)'],
                'id-profound': ['Intellectual Disability (moderate to profound)', 'Intellectual Disability (mild to profound)'],
                'physical': ['Physical disability'],
                'hub': ['Specialist Inclusion Hub'],
            }[this.selectedSpecialisation];
            // EventBus.$emit('change-boundaryset');
            EventBus.$emit('change-specialisation-filter');
            // window.app.Map.specialisationFilter = this.selectedSpecialisation;
        },
        */
        showPrompt() {
            window.localStorage.setItem('showPrompt', this.showPrompt);
        },
    },
    created() {
        window.app.BoundarySelector = this;
        EventBus.$on('school-select', (school) =>
            this.findBoundarySetForSchool(school, 'school-select')
        );
    },
    methods: {
        getBoundarySetTitle(year = this.year, includeStage = false) {
            let r;
            if (!year) {
                return '';
            }
            if (year.match(/^year/)) {
                r = 'Secondary'; // (See #127) // year.replace('year', 'Year ');
            } else {
                r =
                    {
                        primary: 'Primary',
                        juniorsec: 'Junior Secondary',
                        seniorsec: 'Senior Secondary',
                        singlesex: 'Single-sex',
                        specialist: 'Specialist',
                    }[year] || 'Other';
            }
            return r + (includeStage ? ` (${this.stage})` : '');
        },
        change() {
            // EventBus.$emit('change-boundaryset');
        },
        findBoundarySetForSchool(school, source) {
            if (!school) {
                return;
            }
            this._nextSource = source;
            /* happens when user searches for a school that is not in the currently selected type
            now we need to find a boundary set which can show it, as unconfusingly as possible

            In particular:
            - Senior secondary and singlesex should always be shown on those selectors
            - Junior secondary should be shown on primary if we're already on that tab, otherwise on the Jr Sec tab
            - otherwise, avoid switching tabs if we can
            */
            const hasYear = (year) =>
                school.properties[`${year}_${this.stage}`];
            const p = school.properties;
            const allSecondaryYears = [
                ...this.secondaryYears,
                ...this.limitedYears,
            ];
            if (hasYear(this.year)) {
                // if the currently selected year matches the school, don't switch
            } else if (allSecondaryYears.find(hasYear)) {
                // otherwise, work from Year 7 to 12, then juniorsec, seniorsec, singlesex
                this.selectedYearGroup = 'secondary';
                this.selectedSecondaryYear = allSecondaryYears.find(hasYear);
            } else if (hasYear('primary')) {
                this.selectedYearGroup = 'primary';
            } else if (hasYear('specialist')) {
                this.selectedYearGroup = 'specialist';
            } else {
                this.selectedYearGroup = 'other';
            }
            this.$nextTick(() => (this._nextSource = null));
        },
    },
};

function getCookie(key, fallback) {
    return window.location.hash.match(/nocookie/)
        ? fallback
        : window.localStorage.getItem(key) || fallback;
}
</script>

<style scoped>
label.title {
    display: block;
    margin-bottom: 0.5em;
    color: #af272f;
}

input[type='radio'] {
    opacity: 0;
    position: absolute;
}

input[type='radio']:focus + label {
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}

.school-types {
    display: flex;
    align-items: flex-start;
    flex-flow: row wrap;
    border-radius: 3px;
}
.round-left {
    border-radius: 3px 0 0 3px;
}

.round-right {
    border-radius: 0 3px 3px 0;
}

.top-group {
    flex-grow: 1;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

label.btn {
    padding: 10px;
    border: 1px solid hsl(0, 0%, 95%);
    text-transform: capitalize;
    cursor: pointer;
    text-align: center;
    font-size: 12px;
}

label.btn:hover {
    color: hsl(220, 80%, 25%);
    border-color: hsl(0, 0%, 70%);
}

input[type='radio']:checked + label.btn,
.multiple-year-group input[type='radio']:checked + label.btn {
    color: white;
    border: 1px solid #af272f;
    background: #af272f;
}

.description {
    display: none;
}
input[type='radio']:checked + label.btn .description {
    background: white;
    color: #555;
    display: block;
    padding: 8px;
    text-transform: none;
    text-align: left;
}

.not-ready input[type='radio']:checked + label.btn,
.not-ready .multiple-year-group input[type='radio']:checked + label.btn {
    background: hsl(356.5, 63.6%, 92%);
}

.secondary-options {
    width: 100%;
    border: 1px solid hsl(0, 0%, 95%);
    margin-top: 8px;
    position: relative;
    border-radius: 3px;
    padding: 0.25em;
}

.secondary-options:after {
    content: '';
    position: absolute;
    top: -14px;
    right: 48%;
    transform: rotate(-45deg);

    width: 0px;
    height: 0px;
    border: 5px solid #af272f;
    border-color: transparent transparent #af272f #af272f;
}

.multiple-year-group label.btn {
    border-radius: 3px 3px;
    margin: 0.25em;
    background: white;
    width: 100%;
}

#stages {
    transition: opacity 0.3s;
    margin-bottom: 1em;
}

#specialist {
    width: 33%;
}

#primary,
#secondary {
    width: 33%;
}

.multiple-year-group {
    display: flex;
    width: 100%;
}

.multiple-year-group-categories {
    flex-wrap: wrap;
}

.multiple-year-group span {
    flex-grow: 1;
    display: flex;
}

.multiple-year-group label {
    width: 100%;
    font-size: 10pt;
    padding: 5px;
    text-align: center;
}

.multiple-year-group-categories label {
    width: calc(50% - 1em - 5.5px);
}

label[for='yeargroup-singlesex'] {
    width: 100%;
}

.multiple-year-group label:hover {
    background: hsla(0, 0%, 90%, 0.5);
}

.bold {
    font-weight: bold;
}

.w100 {
    width: 100%;
    display: block;
}

.guidance {
    /* color:hsl(0,50%,60%); */
    font-size: 14px;
    margin: 8px 0px;
}
</style>
